import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function About() {
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);
    const navigate = useNavigate();

  return (
    <div style={{ background: '#0A0F1E', minHeight: '100vh', color: 'white', fontFamily: 'Arial, sans-serif', boxSizing: 'border-box' }}>

      {/* Header */}
      <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 2rem', borderBottom: '1px solid #1a2640' }}>
        <span onClick={() => navigate('/')}
          style={{ color: '#00D4AA', fontWeight: 'bold', fontSize: '1.5rem', cursor: 'pointer' }}>
          CrackPrep
        </span>
        <button onClick={() => navigate(-1)}
          style={{ background: 'transparent', color: '#8899aa', border: '1px solid #1a2640', padding: '0.5rem 1rem', borderRadius: '6px', cursor: 'pointer' }}>
          ← Back
        </button>
      </nav>

      {/* Hero */}
      <div style={{ textAlign: 'center', padding: '5rem 2rem 4rem', borderBottom: '1px solid #1a2640' }}>
        <h1 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '1.5rem', lineHeight: 1.2 }}>
          Built by people who've<br />
          <span style={{ color: '#00D4AA' }}>been in your shoes.</span>
        </h1>
        <p style={{ fontSize: '1.15rem', color: '#8899aa', maxWidth: '650px', margin: '0 auto', lineHeight: 1.8 }}>
          CrackPrep was built by IIT and ISB graduates who have sat on both sides of the interview table and know exactly what separates candidates who get the offer from those who don't.
        </p>
      </div>

      {/* The Problem */}
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '4rem 2rem' }}>

        <div style={{ marginBottom: '4rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <div style={{ width: '4px', height: '2rem', background: '#00D4AA', borderRadius: '2px' }} />
            <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', margin: 0 }}>The problem we set out to solve</h2>
          </div>
          <p style={{ color: '#8899aa', lineHeight: 1.9, fontSize: '1rem', marginBottom: '1rem' }}>
            Every year, lakhs of talented candidates apply to top-tier roles at MBB, Big4, Google, Flipkart, and Goldman Sachs. Most of them are qualified. Most of them never hear back.
          </p>
          <p style={{ color: '#8899aa', lineHeight: 1.9, fontSize: '1rem', marginBottom: '1rem' }}>
            The reason isn't talent, it's preparation. A resume that doesn't pass ATS screening never reaches a human. A candidate who hasn't studied the company's culture stumbles in the HR round. A first-time consultant who hasn't practised case frameworks freezes under pressure.
          </p>
          <p style={{ color: '#8899aa', lineHeight: 1.9, fontSize: '1rem' }}>
            The tools that existed to fix this were either generic (a one-size-fits-all ATS scanner), expensive (₹5,000+ coaching sessions), or incomplete (resume help but no interview prep). Nothing gave you the full picture, tailored to your specific resume and your specific target role.
          </p>
        </div>

        {/* Stats bar */}
        <div style={{ background: '#141B2D', borderRadius: '12px', padding: '2rem', marginBottom: '4rem', border: '1px solid #1a2640' }}>
          <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '2rem', textAlign: 'center' }}>
            {[
              { number: '300+', label: 'Job profiles studied' },
              { number: '200+', label: 'Successful candidates analysed' },
              { number: '15+', label: 'Industries covered' },
              { number: '50+', label: 'Top companies mapped' },
            ].map(stat => (
              <div key={stat.label}>
                <div style={{ fontSize: '2.2rem', fontWeight: 'bold', color: '#00D4AA', marginBottom: '0.25rem' }}>{stat.number}</div>
                <div style={{ color: '#8899aa', fontSize: '0.85rem' }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* How we built it */}
        <div style={{ marginBottom: '4rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <div style={{ width: '4px', height: '2rem', background: '#00D4AA', borderRadius: '2px' }} />
            <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', margin: 0 }}>How we built CrackPrep</h2>
          </div>
          <p style={{ color: '#8899aa', lineHeight: 1.9, fontSize: '1rem', marginBottom: '1rem' }}>
            We didn't build CrackPrep by guessing what interviewers want. We spent months studying hundreds of real job profiles — the resumes, cover letters, and backgrounds of candidates who successfully cracked roles at top consulting firms, product companies, investment banks, and tech giants.
          </p>
          <p style={{ color: '#8899aa', lineHeight: 1.9, fontSize: '1rem', marginBottom: '1rem' }}>
            We mapped what ATS systems actually penalise. We catalogued the exact case study formats BCG uses vs the ones Accenture Strategy prefers. We documented the cultural values that Goldman Sachs probes for vs the ones Flipkart cares about. We built a system that knows the difference and applies that knowledge to your specific profile.
          </p>
          <p style={{ color: '#8899aa', lineHeight: 1.9, fontSize: '1rem' }}>
            The result is an AI that doesn't give you generic advice. It gives you preparation that feels like it was written by someone who already knows your target company inside out because in many ways, it was.
          </p>
        </div>

        {/* What makes us different */}
        <div style={{ marginBottom: '4rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <div style={{ width: '4px', height: '2rem', background: '#00D4AA', borderRadius: '2px' }} />
            <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', margin: 0 }}>What makes CrackPrep different</h2>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {[
              {
                icon: '🎯',
                title: 'Tailored to your exact target',
                desc: 'Not generic prep. CrackPrep reads your resume and your target JD and generates questions, cases, and improvements specific to that combination — not a template.'
              },
              {
                icon: '🧠',
                title: 'Role-aware intelligence',
                desc: 'Applying to a consulting firm? You get real case studies. Going for a PM role? You get product case frameworks. Engineering? System design questions at your target company\'s scale. The prep matches the role.'
              },
              {
                icon: '₹',
                title: 'Priced for India',
                desc: 'A single coaching session costs ₹3,000–10,000. CrackPrep gives you a complete analysis — ATS score, full resume fixes, and 50+ interview questions with model answers — starting at ₹79.'
              },
              {
                icon: '⚡',
                title: 'Ready in minutes',
                desc: 'Upload your resume. Paste the JD. In under 5 minutes you have everything you need to walk into that interview prepared.'
              },
            ].map(item => (
              <div key={item.title} style={{ background: '#141B2D', borderRadius: '10px', padding: '1.25rem 1.5rem', border: '1px solid #1a2640', display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                <div style={{ fontSize: '1.5rem', minWidth: '2rem' }}>{item.icon}</div>
                <div>
                  <div style={{ fontWeight: 'bold', marginBottom: '0.4rem', fontSize: '1rem' }}>{item.title}</div>
                  <div style={{ color: '#8899aa', fontSize: '0.9rem', lineHeight: 1.6 }}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Founder note */}
        <div style={{ background: '#141B2D', borderRadius: '12px', padding: '2rem', border: '1px solid #1a2640', marginBottom: '4rem' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1.5rem' }}>
            <div style={{ width: '48px', height: '48px', background: '#00D4AA', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0A0F1E', fontWeight: 'bold', fontSize: '1.2rem', flexShrink: 0 }}>
              S
            </div>
            <div>
              <p style={{ color: '#ccddee', lineHeight: 1.9, fontSize: '0.95rem', fontStyle: 'italic', marginBottom: '1rem' }}>
                "I've seen brilliant people get rejected because their resume never made it past the ATS filter. I've seen IIM graduates freeze in case interviews because they hadn't seen the right formats. CrackPrep exists to make sure preparation is never the reason someone doesn't get the job they deserve."
              </p>
              <div style={{ fontWeight: 'bold', color: 'white', fontSize: '0.9rem' }}>Sanchay - Founder, CrackPrep</div>
              <div style={{ color: '#00D4AA', fontSize: '0.8rem', marginTop: '0.2rem' }}>IIT Bombay · ISB Hyderabad</div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div style={{ textAlign: 'center', padding: '2rem', background: '#141B2D', borderRadius: '12px', border: '1px solid #1a2640' }}>
          <h3 style={{ fontSize: '1.4rem', marginBottom: '0.75rem' }}>
            Ready to walk in <span style={{ color: '#00D4AA' }}>prepared?</span>
          </h3>
          <p style={{ color: '#8899aa', marginBottom: '1.5rem', fontSize: '0.95rem' }}>
            Your first analysis is completely free. No credit card required.
          </p>
          <button
            onClick={() => navigate('/analyze')}
            style={{ background: '#00D4AA', color: '#0A0F1E', border: 'none', padding: '0.875rem 2.5rem', borderRadius: '8px', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer' }}>
            Analyze My Resume →
          </button>
        </div>

      </div>

      {/* Footer */}
      <div style={{ borderTop: '1px solid #1a2640', padding: '2rem', textAlign: 'center' }}>
        <span style={{ color: '#00D4AA', fontWeight: 'bold', fontSize: '1.2rem' }}>CrackPrep</span>
        <p style={{ color: '#8899aa', fontSize: '0.85rem', marginTop: '0.5rem', marginBottom: '0.75rem' }}>
          AI-powered resume and interview preparation for the Indian job market
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', fontSize: '0.85rem' }}>
          <button onClick={() => navigate('/pricing')} style={{ background: 'transparent', border: 'none', color: '#8899aa', cursor: 'pointer', fontSize: '0.85rem' }}>Pricing</button>
          <button onClick={() => navigate('/terms')}   style={{ background: 'transparent', border: 'none', color: '#8899aa', cursor: 'pointer', fontSize: '0.85rem' }}>Terms</button>
          <button onClick={() => navigate('/privacy')} style={{ background: 'transparent', border: 'none', color: '#8899aa', cursor: 'pointer', fontSize: '0.85rem' }}>Privacy</button>
          <button onClick={() => navigate('/contact')} style={{ background: 'transparent', border: 'none', color: '#8899aa', cursor: 'pointer', fontSize: '0.85rem' }}>Contact</button>
        </div>
      </div>

    </div>
  );
}